import React from 'react';
import ReactDOM from 'react-dom';

//add fonts
import './fonts/Montserrat-Regular.ttf';
import './fonts/Montserrat-ExtraBold.ttf';
import 'normalize.css'

import './index.css';
import App from './App/App';
import Router from './Router';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Router />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
